module.exports = __webpack_public_path__ + "img/LTS_FNB.0b1e9ac4.gif";